import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  subtext?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  subtext,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    onClick?.();
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-42">
      <button onClick={handleClick} className="bg-[#2D5A27] hover:bg-[#3a7333] text-white font-bold py-3 md:py-4 px-8 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 text-base md:text-xl w-full md:w-auto text-center" data-id="element-43">
        {children}
      </button>
      {subtext && <span className="text-sm text-gray-600 mt-3 font-medium" data-id="element-44">
          {subtext}
        </span>}
    </div>;
}